const theme = {
  colors: {
    __white: '#ffffff',
    __gray: {
      200: '#f6f6f6',
      250: '#e9ecef',
      300: '#dee2e6',
      500: '#8b949c',
      700: '#6c757d',
      750: '#495057',
    },
    __blue: {
      100: '#b7d0e7',
      500: '#1D83E2',
      550: '#1D86FF',
      575: '#1b72d6',
      600: '#457b9d',
      700: '#043079',
    },
    __green: {
      100: '#a6e9c9',
      200: '#7ef6b7'
    },
  },
};

export default theme;
